import { render, staticRenderFns } from "./bao-cao-doanh-thu.vue?vue&type=template&id=239c33ec&scoped=true&"
import script from "./bao-cao-doanh-thu.vue?vue&type=script&lang=js&"
export * from "./bao-cao-doanh-thu.vue?vue&type=script&lang=js&"
import style0 from "./bao-cao-doanh-thu.vue?vue&type=style&index=0&id=239c33ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239c33ec",
  null
  
)

export default component.exports